import React from 'react';
import { RegularButton } from 'fronton-react';
import { TrashIcon } from '@fronton/icons-react';
import { useTranslation } from 'react-i18next';
import { useAkinatorAnalyticsEvent } from './hooks/use-akinator-analytics-event';
import { useSearchHistoryContext } from '../../hooks/use-search-history-context';

export const AkinatorClearHistoryButton: React.FC = () => {
  const { t } = useTranslation();
  const { clear } = useSearchHistoryContext();
  const sendAnalytics = useAkinatorAnalyticsEvent(`Очистить/весь`, '');

  return (
    <RegularButton
      variant="outline"
      size="s"
      rounded
      label={t('header.searchbar.clear-history')}
      iconOnly
      onClick={() => {
        clear();
        sendAnalytics();
      }}
    >
      <TrashIcon type="fill" />
    </RegularButton>
  );
};
